import { IDestroyOptions, Sprite, Text, TextStyle } from "pixi.js";
import { ICanvasScaler } from "../../../../../canvas/ICanvasScaler";
import { PromiseCompletionSource } from "../../../../../shared/async/PromiseCompletionSource";
import { BaseScalableView } from "../../../common/BaseScalableView";
import { GameFont } from "../../../common/GameFont";
import { ButtonWithScaleAndPosYAnimation } from "../../../common/components/ButtonWithScaleAndPosYAnimation";
import { CommonResourcesPackage } from "../../../common/resources/CommonResourcesPackage";
import { WalletDisconnectionContainer } from "../components/disconnect/WalletDisconnectionContainer";
import { WalletDisconnectionResourcePackage } from "../resources/WalletDisconnectionResourcePackage";

export class WalletDisconnectionPopupView extends BaseScalableView<boolean> {
    private static readonly HEADER_TEXT = 'DISCONNECT\nWALLET?';

    private readonly walletDisconnectionResources: WalletDisconnectionResourcePackage;
    private readonly commonResources: CommonResourcesPackage;

    private viewBackground: Sprite;
    private leftLight: Sprite;
    private rightLight: Sprite
    private warningIcon: Sprite;
    private headerText: Text;
    private frameContainer: WalletDisconnectionContainer;
    private closeButton: ButtonWithScaleAndPosYAnimation;

    public constructor(
        operationControls: PromiseCompletionSource<boolean>,
        canvasScaler: ICanvasScaler,
        walletDisconnectionResources: WalletDisconnectionResourcePackage,
        commonResources: CommonResourcesPackage
    ) {
        super(operationControls, canvasScaler);
        this.walletDisconnectionResources = walletDisconnectionResources;
        this.commonResources = commonResources;
        this.build();
        this.layout(this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
    }

    public start(): void { }

    private build(): void {
        this.viewBackground = new Sprite(this.commonResources.assets_common_blured_backgrounds_blurry_lobby_jpg);
        this.viewBackground.eventMode = "static";
        this.addChild(this.viewBackground);
        this.leftLight = new Sprite(this.commonResources.assets_common_ui_lights_light_left_png);
        this.addChild(this.leftLight);
        this.rightLight = new Sprite(this.commonResources.assets_common_ui_lights_light_left_png);
        this.rightLight.scale.x = -1;
        this.addChild(this.rightLight);
        this.warningIcon = new Sprite(this.walletDisconnectionResources.assets_views_wallet_disconnection_warning_icon_png);
        this.warningIcon.angle = -4.16;
        this.addChild(this.warningIcon);
        this.headerText = new Text(WalletDisconnectionPopupView.HEADER_TEXT, new HeaderTextStyle());
        this.headerText.skew.x = -0.08;
        this.headerText.angle = -5;
        this.addChild(this.headerText);
        this.frameContainer = new WalletDisconnectionContainer(this.walletDisconnectionResources, this.commonResources);
        this.frameContainer.onConfirmButtonClick.add(this.onConfirmButtonClickHandle, this);
        this.frameContainer.onDeclineButtonClick.add(this.closeButtonClickHandle, this);
        this.addChild(this.frameContainer);
        this.closeButton = new ButtonWithScaleAndPosYAnimation(this.commonResources.assets_common_x_png);
        this.closeButton.onUp.add(this.closeButtonClickHandle, this);
        this.addChild(this.closeButton);
    }

    private layout(width: number, _height: number): void {
        this.leftLight.position.set(0, 861);
        this.rightLight.position.set(width, 861);
        this.warningIcon.position.set(228, 264);
        this.headerText.position.set(142, 608);
        this.frameContainer.position.set(58, 843);
        this.closeButton.position.set(373, 1427);
    }

    private async closeButtonClickHandle(): Promise<void> {
        this.operationControls.complete(false);
    }

    private async onConfirmButtonClickHandle(): Promise<void> {
        this.operationControls.complete(true);
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.frameContainer.onConfirmButtonClick.remove(this.onConfirmButtonClickHandle, this);
        this.frameContainer.onDeclineButtonClick.remove(this.closeButtonClickHandle, this);
        this.closeButton.onUp.remove(this.closeButtonClickHandle, this);
        super.destroy(options);
    }
}

class HeaderTextStyle extends TextStyle {
    public constructor() {
        super({
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 148,
            fill: [
                "#fc7039",
                "#f72477"
            ],
            fillGradientType: 1,
            lineHeight: 131
        })
    }
}
